import { useQuery } from "@tanstack/react-query";
import SoftwareAttachmentsService from "src/modules/data-protection/apis/SoftwareAttachmentsService";

const useSoftwareDocuments = ({ softwareId, enabled = true } = {}) => {
    return useQuery({
        queryKey: ["data-protection-fetch-software-attachments-list", softwareId],
        queryFn: async () => {
            const service = SoftwareAttachmentsService.getInstance();

            return await service.list(softwareId);
        },
        enabled: Boolean(softwareId && enabled),
        refetchOnWindowFocus: false,
    });
};

export default useSoftwareDocuments;
